// components/Composite/IconBullets/IconBullets.js
import React from "react";
import PropTypes from "prop-types";
import { IconBullet } from "../../Molecules";
import HorizontalScroll from "../../Molecules/HorizontalScroll/HorizontalScroll";
import { RawHtml } from '../../Utilities';

const IconBullets = ({ value }) => {
  const headingLabel      = value?.headingLabel || '';
  const sectionHeading    = value?.heading || value?.title || '';
  const sectionSubHeading = value?.subHeading || value?.sub_heading || '';
  const sectionIntro      = value?.intro || '';
  const bulletItems       = value?.iconBullets || value?.icon_bullets || [];
  const isHorizontal      = value?.horizontalLayout === true;

  const validBullets = bulletItems.filter(
    (bullet) => bullet && (bullet.heading || bullet.description)
  );

  const hasBullets = validBullets.length > 0;
  const hasHeader  = headingLabel || sectionHeading || sectionSubHeading || sectionIntro;

  if (!hasBullets && !hasHeader) return null;

  const SectionHeader = hasHeader && (
    <div className="section__header">
      <div className="stack stack-normal">
        {headingLabel      && <div className="text-label">{headingLabel}</div>}
        {sectionHeading    && <div className="text-section-title">{sectionHeading}</div>}
        {sectionSubHeading && <p className="text-section-support">{sectionSubHeading}</p>}
        {sectionIntro      && <p className="text-body"><RawHtml html={sectionIntro} /></p>}
      </div>
    </div>
  );

  if (isHorizontal) {
    return (
      <section className="section section-full">
        <div className="section__inner">
          {SectionHeader}
          {hasBullets && (
            <div className="section__body">
              <HorizontalScroll
                items={validBullets}
                itemWidth={300}
                gap="normal"
                showArrows={true}
              >
                {(bullet) => (
                  <IconBullet
                    icon={bullet.icon}
                    heading={bullet.heading || 'Untitled'}
                    description={bullet.description || ''}
                  />
                )}
              </HorizontalScroll>
            </div>
          )}
        </div>
      </section>
    );
  }

  return (
    <section className="section section-full">
      <div className="section__inner">
        {SectionHeader}
        {hasBullets && (
          <div className="section__body">
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-blocks">
              {validBullets.map((bullet, index) => (
                <IconBullet
                  key={index}
                  icon={bullet.icon}
                  headingLabel={bullet.headingLabel}
                  heading={bullet.heading || 'Untitled'}
                  description={bullet.description || ''}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

IconBullets.propTypes = {
  value: PropTypes.shape({
    headingLabel:     PropTypes.string,
    heading:          PropTypes.string,
    subHeading:       PropTypes.string,
    intro:            PropTypes.string,
    title:            PropTypes.string,
    sub_heading:      PropTypes.string,
    horizontalLayout: PropTypes.bool,
    iconBullets:      PropTypes.arrayOf(PropTypes.object),
    icon_bullets:     PropTypes.arrayOf(PropTypes.object),
  }),
};

export default IconBullets;